const lang = {
  page_title: 'メンバー',
  breadcrumb: {
    list: 'メンバー',
  },
  button: {},
  table: {
    name: 'アカウント名',
    email: 'メールアドレス',
    edit: '編集',
  },
}

export default lang
